require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./articles-tags-gr-8-paper-push.json") })
        }
      }, "path---articles-tags-gr-8-paper-push");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---articles-tags-gr-8-paper-push!./.cache/json/articles-tags-gr-8-paper-push.json
// module id = 1830
// module chunks = 231608221292675